export const initialBringFriendErrors = {
  parent: {
    name: '',
    email: '',
  },
  friend: {
    name: ''
  }
}